import { api } from '../../ApiHandler';

export const CheckEmailAvailableRequest = (email: string): Promise<boolean> => {
	return api()
		.post('auth/register/email', { email })
		.then(response => response.data.data.available);
};
